import { all, call, put, takeLatest, takeEvery } from '@redux-saga/core/effects';
import axios from 'axios';

import { requestCreateComment, requestViewComments, requestDeleteComment } from './comment.actions';
import { getCreateCommentRequest, getViewCommentsRequest, getDeleteCommentRequest } from './comment.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';

import { SUCCESS, ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

export function* performCreateCommentRequest({ payload }) {
  const { input, onSuccess } = payload;

  try {
    yield put(addSpinner('Creating Comment'));

    const [endpoint, options] = getCreateCommentRequest(input);

    yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(removeSpinner('Creating Comment'));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner('Creating Comment'));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForCreateCommentRequest() {
  yield takeLatest(requestCreateComment.type, performCreateCommentRequest);
}

export function* performViewCommentsRequest({ payload }) {
  const { postExternalReference, page, size, onSuccess } = payload;

  try {
    const [endpoint, options] = getViewCommentsRequest(postExternalReference, page, size);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess, data.comments);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForViewCommentsRequest() {
  yield takeEvery(requestViewComments.type, performViewCommentsRequest);
}

export function* performDeleteCommentRequest({ payload }) {
  const { commentExternalReference, onSuccess } = payload;

  try {
    yield put(addSpinner('Deleting Comment'));

    const [endpoint, options] = getDeleteCommentRequest(commentExternalReference);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(removeSpinner('Deleting Comment'));
    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner('Deleting Comment'));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForDeleteCommentRequest() {
  yield takeLatest(requestDeleteComment.type, performDeleteCommentRequest);
}

export default function* commentSaga() {
  yield all([watchForCreateCommentRequest(), watchForViewCommentsRequest(), watchForDeleteCommentRequest()]);
}
